// extracted by mini-css-extract-plugin
module.exports = {"title":"FAQ_title__1P5p7","faq":"FAQ_faq__1E-9C","open":"FAQ_open__1prDv","question":"FAQ_question__1Tsj7","answer":"FAQ_answer__3LaDe"};